import { render, staticRenderFns } from "./AuditRemarksList.vue?vue&type=template&id=1354beb2&scoped=true&"
import script from "./AuditRemarksList.vue?vue&type=script&lang=js&"
export * from "./AuditRemarksList.vue?vue&type=script&lang=js&"
import style0 from "./AuditRemarksList.vue?vue&type=style&index=0&id=1354beb2&lang=scss&scoped=true&"
import style1 from "./AuditRemarksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1354beb2",
  null
  
)

export default component.exports